<template>
  <div :key="pageKey">
    <div class="page-container">
      <div class="page-content">
        <div class="v-flex grow">
          <div class="logo-container">
            <span>
              <b-button
                variant="clear"
                size="sm"
                data-cy="btn-toggle-nav"
                @click="toggleNav"
                v-if="isAuthenticated"
              >
                <Menu :size="24" />
              </b-button>
            </span>
            <slot name="page-header">
              <h1 v-if="isAuthenticated">
                {{ accessClaims.full_name }}
              </h1>
              <Logo v-else />
            </slot>
            <span><!-- spacer --></span>
          </div>
          <div
            @click="closeNav"
            :class="['card-wrapper v-flex grow', navOpened ? 'opened' : '']"
          >
            <b-card
              header-bg-variant="white"
              body-class="v-flex grow body-content"
              :class="['grow page-card', navOpened ? 'opened' : '']"
            >
              <template #header>
                <div class="page-card-header">
                  <slot name="card-header" />
                </div>
              </template>

              <div class="v-flex grow">
                <slot />
              </div>
            </b-card>
          </div>
          <Drawers>
            <slot name="drawers" />
          </Drawers>
        </div>
        <transition>
          <NavigationMenu
            class="main-nav"
            v-if="navOpened"
            @closeMenu="closeNav"
          />
        </transition>
      </div>
      <div class="page-footer">
        <div class="powered">{{ $t('labels.poweredBy') }} <BlytzLogo /></div>
      </div>
    </div>
    <div v-if="isBusy" class="spinner-container">
      <LoaderCircle />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import Logo from '@/components/Elements/Logo/Logo.vue'
import BlytzLogo from '@/components/Elements/Logo/BlytzLogo.vue'
import NavigationMenu from '@/components/NavigationMenu/NavigationMenu.vue'
import { debounce } from 'lodash-es'
import Drawers from '@/components/Elements/Drawer/Drawers.vue'
import { mapGetters, mapMutations } from 'vuex'
import { Menu, LoaderCircle } from 'lucide-vue'

@Component({
  components: {
    BlytzLogo,
    Logo,
    NavigationMenu,
    Drawers,
    Menu,
    LoaderCircle
  },
  methods: {
    ...mapMutations(['setBusyCount'])
  },
  computed: {
    ...mapGetters(['accessClaims', 'busyCount', 'isAuthenticated'])
  }
})
export default class Page extends Vue {
  navOpened = false
  isBusy = false
  setBusyCount!: Function
  busyCount: Function
  pageKey = 0

  mounted() {
    const pageContent = document.querySelector('.page-content')
    pageContent.addEventListener('scroll', (e: any) => {
      // automatically close if content is dragged far enough to left and reset
      if (e.target.scrollLeft > 320) {
        this.navOpened = false
        this.pageKey + 1
      }
    })
  }

  toggleNav() {
    this.navOpened = !this.navOpened
  }

  busyChecker() {
    this.isBusy = Boolean(this.busyCount())
  }
  debouncedBusyChecker = debounce(this.busyChecker, 200, { trailing: true })
  @Watch('busyCount')
  busyCountChanged() {
    this.debouncedBusyChecker()
  }
  get showNav(): boolean {
    const showNav = this.$route.meta.hideNav
    return typeof showNav !== undefined ? showNav : true
  }

  closeNav() {
    this.navOpened = false
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/PageStyles.scss';
</style>
